module.exports = __webpack_public_path__ + "img/pink3.21a9e6a8.png";